import { getValidationFieldClasses } from '../utils.js'

Vue.component('address-form', {
    props: {
        'data': {
            type: Object,
            required: false,
            default: function() {
                return {};
            }
        },
        'parentFormErrors': {
            type: Object
        },
    },

    data: function() {
        return {
            form: {
                street:  '' ,
                number:  '' ,
                zip:  '' ,
                city:  '' ,
                country:  '' ,
            }
        }
    },

    mounted: function() {

        this.form = this.data;

    },
   /*
    watch: {

        'parentFormErrors': {
            deep: true,
            handler (newVal, oldVal) {
                var bag = this.$validator.errors;
                var errors = newVal;

                bag.items = [];
                errors.items.map(function(item) {
                    if(item && item.field) {
                        bag.add(item.field.replace('address_', 'address.').replace('address_tags_', 'address_tags.'), item.msg);
                    }
                });
            }
        }
    },   */

    methods: {
        getData() {
            return this.form;
        },

        validate(event) {
            this.$validator.errors.remove(event.target.name);
        },

        getValidationFieldClasses,
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/address/Form.js